import firebase from "firebase";
import { config } from "../../../config/firebase";

const app = firebase.initializeApp(config);

export const auth = app.auth();
export default app;
